import { useEffect, useMemo, useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import { electronicInvoicingApi } from "../../api/electronicInvoicingApi";

export default function ReceivedInvoicesPage() {
  const { token } = useAuth() as any;
  const [rows, setRows] = useState<any[]>([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    electronicInvoicingApi.listReceivedInvoices(token).then(setRows).catch(() => setRows([]));
  }, [token]);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return rows;
    return rows.filter((r) =>
      String(r.supplierName ?? "").toLowerCase().includes(s) ||
      String(r.supplierVat ?? "").toLowerCase().includes(s) ||
      String(r.documentNumber ?? "").toLowerCase().includes(s),
    );
  }, [rows, q]);

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Fatture ricevute</h3>
        <input
          className="form-control"
          style={{ width: 320 }}
          placeholder="Filtra fornitore / P.IVA / documento"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>
      <div className="card shadow-sm">
        <div className="table-responsive">
          <table className="table table-hover mb-0">
            <thead className="table-light">
              <tr>
                <th>Fornitore</th>
                <th>P.IVA</th>
                <th>Documento</th>
                <th>Data</th>
                <th>Totale</th>
                <th>XML</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((r) => (
                <tr key={r.id}>
                  <td>{r.supplierName ?? "-"}</td>
                  <td>{r.supplierVat ?? "-"}</td>
                  <td>{r.documentNumber ?? "-"}</td>
                  <td>{r.documentDate ? new Date(r.documentDate).toLocaleDateString("it-IT") : "-"}</td>
                  <td>{r.total ?? "-"}</td>
                  <td>{r.xmlPath ? <a href={r.xmlPath}>Download XML</a> : "-"}</td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={6} className="text-center text-muted py-4">Nessuna fattura ricevuta</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
